export const ListOfCity = {
    "JKT": "Jakarta",
    "PNT": "Pontianak",
    "TNG": "Tangerang",
    "BDO": "Bandung",
    "SRB": "Surabaya",
    "SMR": "Semarang",
    "MD": "Medan",
    "BPN": "Balikpapan",
    "PLB": "Palembang",
    "BGR": "Bogor",
    "BTM": "Batam",
    "BKS": "Bekasi",
    "SLT": "Salatiga",
    "MDN": "Madiun",
    "KDS": "Kudus",
    "BLR": "Blora",
    "DPK": "Depok",
    "YKT": "Yogyakarta",
    "SID": "Sidoarjo",
}